export default __webpack_public_path__ + "static/media/icon-search-blue.df9fd52a.svg";